import FieldString from "../../../fields3/generic/string/string"
import FieldConfig from "../../../fields3/proto/field-config"
import {GROUP_INFO} from "../../../gd/const/fields/field2-groups"
import FieldCopyContent_FormElementView from "./render/form-element-view"
import FieldCopyContentButton from "./render/copy-button"

export default class FieldCopyContent extends FieldString {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Copy content";
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Copy content field"
        this.icon               = 'i5-copy';

        _.assign(this.components, {
            ButtonComponent: FieldCopyContentButton
        })

        _.assign(this.renderComponents,{
            formElementView: FieldCopyContent_FormElementView,
        })
    }
}